import React, { useEffect, useState } from 'react';
import ShortId from './ShortId';

// Who a member has been suggested in a community and how each side answered,
// plus how much they looked at those profiles (suggestionprofileviews — only
// recorded from 15 Oct 2026) and who has opened theirs.

const fmtDate = (d) => (d ? new Date(d).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');
const ANSWER = { interested: '✅ interested', not_interested: '❌ not interested' };

const engagement = (v) => {
  if (!v || v.opens === 0) return 'Not opened';
  const photos = v.photoCount ? ` · ${v.mostPhotosSeen}/${v.photoCount} photos` : '';
  return `Opened ${v.opens}× · ${v.totalSeconds}s${photos} · last ${fmtDate(v.lastOpenedAt)}`;
};

const SuggestionActivity = ({ communityId, userId, authedFetch, memberName = 'They' }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    authedFetch(`/admin/communities/${communityId}/members/${userId}/suggestion-activity`)
      .then((d) => { if (!cancelled) setData(d); })
      .catch((err) => { if (!cancelled) setError(`Couldn't load suggestions (${err.message})`); });
    return () => { cancelled = true; };
  }, [communityId, userId, authedFetch]);

  return (
    <div>
      <h4 style={{ margin: '0.9rem 0 0.3rem' }}>Suggestions &amp; engagement</h4>
      {error && <div className="as-error">{error}</div>}
      {!data && !error && <div className="as-card-meta">Loading…</div>}
      {data && data.suggestions.length === 0 && <div className="as-card-meta">No suggestions yet in this community.</div>}
      {data?.suggestions.map((s) => (
        <div key={s.userId} style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: '0.5rem 0.7rem', margin: '0.4rem 0', fontSize: '0.9rem' }}>
          <div>
            <strong>{s.firstName}</strong><ShortId userId={s.userId} />
            {s.age != null && <span className="as-card-meta"> · {s.age}</span>}
            {s.localArea && <span className="as-card-meta"> · {s.localArea}</span>}
            {s.milesAway != null && <span className="as-card-meta"> · <strong>{s.milesAway < 10 ? s.milesAway : Math.round(s.milesAway)} miles away</strong></span>}
          </div>
          <div className="as-card-meta">
            {s.shownToMemberAt.length > 0 ? `Shown to ${memberName} ${fmtDate(s.shownToMemberAt[s.shownToMemberAt.length - 1])}` : `Not shown to ${memberName}`}
            {' · '}
            {s.shownToThemAt.length > 0 ? `${memberName} shown to ${s.firstName} ${fmtDate(s.shownToThemAt[s.shownToThemAt.length - 1])}` : `${s.firstName} hasn't been shown ${memberName}`}
          </div>
          <div>
            {memberName}: {ANSWER[s.memberAnswer] || 'no answer'} · {s.firstName}: {ANSWER[s.theirAnswer] || 'no answer'}
          </div>
          <div className="as-card-meta">{memberName} looked: {engagement(s.memberViews)}</div>
        </div>
      ))}

      {data && (
        <>
          <div className="as-card-meta" style={{ marginTop: '0.6rem', fontWeight: 600 }}>Who has opened {memberName === 'They' ? 'their' : `${memberName}'s`} profile</div>
          {data.viewedBy.length === 0
            ? <div className="as-card-meta">Nobody yet.</div>
            : data.viewedBy.map((v) => (
              <div key={v.userId} className="as-card-meta">
                <strong>{v.firstName}</strong><ShortId userId={v.userId} />{v.age != null ? ` (${v.age})` : ''}{v.milesAway != null ? ` · ${v.milesAway < 10 ? v.milesAway : Math.round(v.milesAway)} mi` : ''}: {engagement(v.views)}
              </div>
            ))}
          <div className="as-card-meta" style={{ marginTop: '0.4rem', fontStyle: 'italic' }}>Profile opening is only recorded from 15 Oct 2026.</div>
        </>
      )}
    </div>
  );
};

export default SuggestionActivity;
